import { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Form, DatePicker, Radio, Input, InputNumber, Button, Row, Col, message, Checkbox } from 'antd';
// import { DeleteOutlined, LeftOutlined } from '@ant-design/icons';
import { SelectionFormItemLayout } from '../../../../utils/property';
import dayjs from 'dayjs';
import { setCasescoringtopicsSetting } from '@services/Selection';
import { handleForm2Params, handleState2Form } from './util';
import PageHeader from '@components/PageHeader/PageHeader';

import './index.less';
const { TextArea } = Input;

const ScoringSettings = () => {
    const params = useParams();
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const local = useLocation();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        document.title = '评分设置-医评议';
    }, []);

    const initialValues = handleState2Form(local.state);
    initialValues.rankShowCounts = local?.state?.rankShowCounts === -1 ? -1 : initialValues.rankShowCounts;
    initialValues.submitCountdown = initialValues.submitCountdown ?? 0;

    const rankForm = Form.useWatch('rankForm', form);
    const scoreMode = Form.useWatch('scoreMode', form);
    const rule = Form.useWatch('rule', form);

    const [caseNumber, setCaseNumber] = useState();

    useEffect(() => {
        if (scoreMode === 1) {
            form.setFieldValue('dimensionEnabled', 1);
        }
    }, [form, scoreMode]);

    const handleCancel = () => {
        navigate(-1);
    };

    // 实践数字改变
    const onChangeNumber = e => {
        setCaseNumber(e);
    };

    const handleSubmit = () => {
        form.validateFields().then(res => {
            if ((res.scoreMode === 1 && !res.dimensions?.length) || res.dimensions?.some(item => !item.name || !item.score || !item.desc)) {
                return message.error('请填写评议维度');
            }
            // 只有在有新增维度的情况下才要判断和是 100
            if (res.dimensions?.length) {
                let sum = 0;
                for (let i = 0; i < res.dimensions.length; i++) {
                    sum += +res.dimensions[i].score || 0;
                }
                if (sum !== 100) {
                    return message.error('评议维度总和应为 100！');
                }
            }

            if (res.rankForm === 2 && (!res.awards?.length || res.awards.some(item => !item.rankBegin || !item.rankEnd || !item.awardName))) {
                return message.error('请填写完整奖项名称！');
            }

            // 上榜实践数
            if (res.rankShowCounts === 0 && !caseNumber) {
                return message.error('请选择结果取值范围！');
            }

            const param = handleForm2Params(res);
            param.rankShowCounts = res.rankShowCounts === -1 ? -1 : caseNumber;

            setLoading(true);

            setCasescoringtopicsSetting({ ...param, id: params.tid }).then(res => {
                setLoading(false);
                if (res.status_code === 200) {
                    message.success('设置成功！');
                    handleCancel();
                }
            });
        });
    };

    return (
        <>
            <PageHeader breadcrumb={[]} className="scoring-setting">
                <span className="back" onClick={() => navigate(-1)}>
                    <i className="bi bi-chevron-left" />
                </span>
                <div className="current-title">评议规则设置</div>
                <span className="current-subtitle wrap-subtitle">
                    {local.state?.projectName}
                    <br />
                    {local.state?.stageName} - {local.state?.topicName}
                </span>
            </PageHeader>

            <div className="page-route-body scoring-setting-content">
                <Form form={form} name="time" {...SelectionFormItemLayout} initialValues={initialValues}>
                    <h2>评议时间设置</h2>
                    <Form.Item label="评议起止时间" name="time" rules={[{ required: true, message: '请选择' }]}>
                        <DatePicker.RangePicker
                            style={{ width: '100%' }}
                            showTime={{
                                hideDisabledOptions: true,
                                defaultValue: [dayjs('00:00', 'HH:mm'), dayjs('11:59', 'HH:mm')],
                            }}
                            format="YYYY-MM-DD HH:mm"
                        />
                    </Form.Item>

                    <h2>评议专家端展示设置</h2>
                    <Form.Item label="提醒弹窗" name="rule" rules={[{ required: true, message: '请选择' }]}>
                        <Radio.Group>
                            <Radio value={0}>不提醒</Radio>
                            <Radio value={1}>每次进入提醒</Radio>
                            <Radio value={2}>仅提醒一次</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item label="提醒内容" name="message" rules={[{ required: rule !== 0, message: '请输入' }]}>
                        <TextArea maxLength={200} showCount />
                    </Form.Item>

                    {/* <Form.Item label="查看评议文件" name="caseFileViewable" rules={[{ required: true, message: '请选择' }]} extra="可查看：展示实践包含的文档，视频，图片；不可查看：只展示实践封面图">
                        <Radio.Group>
                            <Radio value={1}>可查看</Radio>
                            <Radio value={0}>不可查看</Radio>
                        </Radio.Group>
                    </Form.Item> */}

                    <Form.Item name="caseInfoShow" label="实践详情展示" extra="勾选字段将显示在详情页，未勾选则仅展示实践封面图">
                        <Checkbox.Group
                            options={[
                                { label: '成果壁报', value: 'poster' },
                                { label: '文档', value: 'caseDoc' },
                                { label: '图片', value: 'caseImage' },
                                { label: '视频', value: 'caseVideo' },
                            ]}
                        />
                    </Form.Item>

                    <Form.Item label="申报单位" name="unitAvailable" rules={[{ required: true, message: '请选择' }]} extra="匿名：不展示实践申报单位">
                        <Radio.Group>
                            <Radio value={1}>展示</Radio>
                            <Radio value={0}>匿名</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item label="起评分" name="minScore" rules={[{ required: true, message: '请输入' }]}>
                        <InputNumber placeholder="请输入正整数" min={0} max={99} precision={0} />
                    </Form.Item>

                    <Form.Item label="可评小数分" name="decimalPlaceNum" rules={[{ required: true, message: '请选择' }]}>
                        <Radio.Group>
                            <Radio value={0}>不保留</Radio>
                            <Radio value={1}>保留1位</Radio>
                            <Radio value={2}>保留2位</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item label="实践点评" name="commentEnabled" rules={[{ required: true, message: '请选择' }]}>
                        <Radio.Group>
                            <Radio value={0}>不展示</Radio>
                            <Radio value={1}>必填</Radio>
                            <Radio value={2}>非必填</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item label="修改评分" name="scoreChangingTimes" rules={[{ required: true, message: '请选择' }]}>
                        <Radio.Group>
                            <Radio value={0}>提交评分不可修改</Radio>
                            <Radio value={-1}>不限制修改次数</Radio>
                            <Radio value={1}>
                                <span className="flex-span">
                                    <span>限制修改</span>{' '}
                                    <Form.Item name="editLimit">
                                        <InputNumber style={{ width: 60 }} min={1} precision={0} />
                                    </Form.Item>
                                </span>
                            </Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item label="提交评分等待时长" name="submitCountdown" rules={[{ required: true, message: '请输入' }]}>
                        <InputNumber min={0} precision={0} style={{ width: 90 }} suffix="秒" />
                    </Form.Item>

                    <h2>评议方式设置</h2>
                    <Form.Item label="评议方式" name="scoreMode" rules={[{ required: true, message: '请选择' }]}>
                        <Radio.Group>
                            <Radio value={1}>按评议维度打分</Radio>
                            <Radio value={2}>仅给出总分</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item label="评议维度" name="dimensionEnabled" rules={[{ required: scoreMode !== 2, message: '请选择' }]} extra="按评议维度打分时，评议维度不可隐藏">
                        <Radio.Group>
                            <Radio value={1}>展示</Radio>
                            <Radio value={0} disabled={scoreMode === 1}>
                                隐藏
                            </Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.List label="评议维度项" name="dimensions">
                        {(fields, { add, remove }, { errors }) => (
                            <>
                                <Form.Item label="评议维度项" required={scoreMode !== 2} extra="评议维度总分不小于100分">
                                    <Button
                                        onClick={() => {
                                            if (fields.length >= 20) {
                                                return;
                                            }
                                            add();
                                        }}
                                    >
                                        新增维度
                                    </Button>
                                    <Form.ErrorList errors={errors} />
                                </Form.Item>
                                {fields.map(field => (
                                    <Row key={field.key}>
                                        <Col span={7}></Col>
                                        <Col span={17}>
                                            <div className="flex-span margin-span">
                                                <Form.Item noStyle name={[field.name, 'name']}>
                                                    <Input className="flex-span-1" placeholder="评议维度" maxLength={20} showCount />
                                                </Form.Item>
                                                <Form.Item noStyle name={[field.name, 'desc']}>
                                                    <Input className="flex-span-2" placeholder="评议维度说明" maxLength={300} showCount />
                                                </Form.Item>
                                                <Form.Item noStyle name={[field.name, 'score']}>
                                                    <InputNumber className="flex-span-3" placeholder="分值" min={1} max={100} precision={0} />
                                                </Form.Item>
                                                <i className="bi bi-trash" onClick={() => remove(field.name)} />
                                            </div>
                                        </Col>
                                    </Row>
                                ))}
                            </>
                        )}
                    </Form.List>

                    <h2>系统得分计算规则设置</h2>
                    <Form.Item label="平均分计算公式" name="scoreAverageType" rules={[{ required: true, message: '请选择' }]}>
                        <Radio.Group>
                            <Radio value={1}>全部专家评分之和/提交评分的专家数</Radio>
                            <Radio value={2}>去掉最高分和最低分的总分/剩余提交评分的专家数</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item label="平均分保留小数位" name="caseFinalScoreDecimalPlaceNum" rules={[{ required: true, message: '请选择' }]}>
                        <Radio.Group>
                            <Radio value={0}>不保留</Radio>
                            <Radio value={1}>保留1位</Radio>
                            <Radio value={2}>保留2位</Radio>
                            <Radio value={3}>保留3位</Radio>
                            <Radio value={4}>保留4位</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <h2>结果设置</h2>
                    <Form.Item label="结果展示形式" name="rankForm" rules={[{ required: true, message: '请选择' }]}>
                        <Radio.Group>
                            <Radio value={1}>按序号展示</Radio>
                            <Radio value={2}>按结果名称分组展示</Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item label="结果取值范围" name="rankShowCounts" rules={[{ required: true, message: '请选择结果取值范围' }]}>
                        <Radio.Group>
                            <Radio value={-1}>取全部评议实践</Radio>
                            <Radio value={0}>
                                <div>
                                    取前
                                    <InputNumber min={1} onChange={onChangeNumber} value={caseNumber} />
                                    评议实践
                                </div>
                            </Radio>
                        </Radio.Group>
                    </Form.Item>

                    <Form.Item label="同分实践排名向上进位" name="sameRankAddtionEnabled" rules={[{ required: true, message: '请选择' }]} extra="开启示例：1、1、2、3； 关闭示例：1、1、3、4；">
                        <Radio.Group>
                            <Radio value={true}>开启</Radio>
                            <Radio value={false}>关闭</Radio>
                        </Radio.Group>
                    </Form.Item>

                    {rankForm === 2 && (
                        <Form.List label="结果名称" name="awards">
                            {(fields, { add, remove }, { errors }) => (
                                <>
                                    <Form.Item
                                        label="结果名称"
                                        extra={
                                            <>
                                                <span>1. 设置结果名称后，对外结果展示时，排名序号将以结果名称展示；</span>
                                                <br />
                                                <span>2. 为保障每个实践有对应结果名称，设置排名数量时需大于该主题评议实践数</span>
                                            </>
                                        }
                                    >
                                        <Button onClick={() => add()}>新增结果名称</Button>
                                        <Form.ErrorList errors={errors} />
                                    </Form.Item>
                                    {fields.map(field => (
                                        <Row key={field.key}>
                                            <Col span={7}></Col>
                                            <Col span={17}>
                                                <div className="flex-span margin-span">
                                                    <span>分数排名：</span>
                                                    <Form.Item noStyle name={[field.name, 'rankBegin']}>
                                                        <InputNumber placeholder="输入排名" className="flex-span-3" min={0} precision={0} />
                                                    </Form.Item>
                                                    <span>至</span>
                                                    <Form.Item noStyle name={[field.name, 'rankEnd']}>
                                                        <InputNumber placeholder="输入排名" className="flex-span-3" min={0} precision={0} />
                                                    </Form.Item>
                                                    <span>结果名称：</span>
                                                    <Form.Item noStyle name={[field.name, 'awardName']}>
                                                        <Input className="flex-span-1" />
                                                    </Form.Item>
                                                    <i className="bi bi-trash" onClick={() => remove(field.name)} />
                                                </div>
                                            </Col>
                                        </Row>
                                    ))}
                                </>
                            )}
                        </Form.List>
                    )}
                </Form>

                <div className="operation-buttons">
                    <Button onClick={handleCancel}>取消</Button>
                    <Button type="primary" onClick={handleSubmit} loading={loading}>
                        保存
                    </Button>
                </div>
            </div>
        </>
    );
};

export default ScoringSettings;
